import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../../utils/Enums';
import { apiClient } from '../../utils/ApiClient';
import { Setting } from '../../models/Setting';

interface SettingsState {
    settings: Setting[];
    getSettingsStatus: RequestStatus;
    updateSettingsStatus: RequestStatus;
    errors: string[];
}

const initialState: SettingsState = {
    settings: [],
    getSettingsStatus: RequestStatus.Idle,
    updateSettingsStatus: RequestStatus.Idle,
    errors: []
};

export const getSettings = createAsyncThunk('systemSettings/getSettings', async (_, { rejectWithValue, getState }) => {
    const response = await apiClient.get('system-settings');
    return response.data;
});

export const updateSettings = createAsyncThunk('systemSettings/updateSettings', async (updatedSettings: any, { rejectWithValue, getState }) => {
    const response = await apiClient.put('system-settings', updatedSettings);
    return response.data;
});

const systemSettingsSlice = createSlice({
    name: 'systemSettings',
    initialState,
    reducers: {
        resetUpdateSettingsStatus: (state) => {
            state.updateSettingsStatus = RequestStatus.Idle;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSettings.pending, (state) => {
                state.getSettingsStatus = RequestStatus.Loading;
            })
            .addCase(getSettings.fulfilled, (state, action) => {
                state.getSettingsStatus = RequestStatus.Success;
                state.settings = action.payload;
            })
            .addCase(getSettings.rejected, (state) => {
                state.getSettingsStatus = RequestStatus.Failed;
            })
            .addCase(updateSettings.pending, (state) => {
                state.updateSettingsStatus = RequestStatus.Loading;
                state.errors = [];
            })
            .addCase(updateSettings.fulfilled, (state) => {
                state.updateSettingsStatus = RequestStatus.Success;
            })
            .addCase(updateSettings.rejected, (state, action) => {
                state.updateSettingsStatus = RequestStatus.Failed;
                const errors = JSON.parse(action?.error?.message ?? '{}');
                if (errors) {
                    state.errors = Array.isArray(errors.errors) ? errors.errors : [];
                } else {
                    state.errors = ['Tuvastamata viga.'];
                }
            });
    },
});

export const { resetUpdateSettingsStatus } = systemSettingsSlice.actions;
export default systemSettingsSlice.reducer;